/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewInternalServerError
 */
export interface CRSFSecReviewInternalServerError {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewInternalServerError
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewInternalServerError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewInternalServerError
     */
    title: string;
}

/**
 * Check if a given object implements the CRSFSecReviewInternalServerError interface.
 */
export function instanceOfCRSFSecReviewInternalServerError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function CRSFSecReviewInternalServerErrorFromJSON(json: any): CRSFSecReviewInternalServerError {
    return CRSFSecReviewInternalServerErrorFromJSONTyped(json, false);
}

export function CRSFSecReviewInternalServerErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewInternalServerError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'status': json['status'],
        'title': json['title'],
    };
}

export function CRSFSecReviewInternalServerErrorToJSON(value?: CRSFSecReviewInternalServerError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'status': value.status,
        'title': value.title,
    };
}

